import { create } from 'zustand'

export interface State {
  open: boolean
  query: string
  position: { x: number; y: number }
}

const useSearch = create<State>()(() => ({
  open: false,
  query: '',
  position: { x: 0, y: 0 },
}))

export const openSearch = () => useSearch.setState({ open: true })
export const closeSearch = () => useSearch.setState({ open: false })
export const setSearchQuery = (query: string) => useSearch.setState({ query })
export const clearSearch = () => useSearch.setState({ query: '' })
export const setSearchPosition = (position: { x: number; y: number }) => useSearch.setState({ position })

export default useSearch
